async function contentfulClient(query: string): Promise<Response> {
	return await fetch(
		`https://graphql.contentful.com/content/v1/spaces/${process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID}/environments/${process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT}`,
		{
			method: 'POST',
			headers: {
				Authorization:
					'Bearer ' + process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				query: `{${query}}`,
			}),
		}
	)
}

export default contentfulClient
